"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CannedAnswerChannelEnum = void 0;
var CannedAnswerChannelEnum;
(function (CannedAnswerChannelEnum) {
    CannedAnswerChannelEnum["Mail"] = "M";
    CannedAnswerChannelEnum["Sms"] = "S";
})(CannedAnswerChannelEnum = exports.CannedAnswerChannelEnum || (exports.CannedAnswerChannelEnum = {}));
